import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { generateId, shortHandDateTime } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import { useGlobalState } from '../../../stateProvider/StateProvider';

const ClaimedDeals = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.mobile.claimedDeal,
        isReport: true,
        headers: [
            {
                label: 'Name',
                propKey: 'name',
            }, {
                label: 'Email',
                propKey: 'email',
            }, {
                label: 'Deal Name',
                propKey: 'dealName',
                options: true
            }, {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Claimed',
                propKey: 'claimedDateTime',
                type: 'dateTime'
            }, {
                label: 'Redeemed',
                propKey: 'redeemedDate',
                type: 'dateTime'
            },
        ],
        quickSort: [
            {
                label: 'Promo Codes',
                propKey: 'codeType',
                query: 'Promo',
                color: '#b5a4e8',
            },
            {
                label: 'Deals',
                propKey: 'codeType',
                query: 'Deal',
                color: '#ff3737',
            },
        ],
        sticker: [
            {
                label: 'Claimed Deals',
                color: '#3479b9',
                callback: (data) => data.length
            }, {
                label: 'Redeemed Deals',
                color: '#5a53c9',
                callback: (data) => data.reduce((a, b) => (b.redeemedDate ? 1 : 0) + a, 0)
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>
                    <LinkTo customerId={e.userId}>{e.name}</LinkTo>
                </td>
                <td>{e.email}</td>
                <td>{e.dealName}</td>
                <td>{e.code}</td>
                <td>{shortHandDateTime(e.claimedDateTime)}</td>
                <td>{e.redeemedDate ? shortHandDateTime(e.redeemedDate) : '-'}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default ClaimedDeals;